import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { dateTimeToStringWithDOW } from "components/Shared/Formatters";

export const orderByStartDateDesc = (a, b) => {
    return a.start > b.start ? -1 : (a.start < b.start ? 1 : 0);
};

const QATouches = ({ qaTouches }) => {
    if (qaTouches.length === 0) {
        return null;
    }

    const sortedTouches = [...qaTouches].sort(orderByStartDateDesc);

    const fields = sortedTouches.map(({ id, author, body, start, end, resolution }) => (
        {
            key: id,
            control:
                <div className="qa-touch-item">
                    <div className="qa-touch-author">{author}</div>
                    <div className="indent qa-touch-comment">{body}</div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="qa-touch-label">Start</td>
                                <td>{dateTimeToStringWithDOW(start)}</td>
                            </tr>
                            <tr>
                                <td className="qa-touch-label">End</td>
                                <td>{dateTimeToStringWithDOW(end)}</td>
                            </tr>
                            <tr>
                                <td className="qa-touch-label">Result</td>
                                <td className="card-value">{resolution}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        }
    ));

    return (
        <MCard
            title="QA Touches"
            fields={fields}
        />
    );
};

QATouches.defaultProps = {
    qaTouches: [],
};

QATouches.propTypes = {
    qaTouches: PropTypes.array,
};

export default QATouches;